// ============================================================
// THEME REGISTRY  —  THE ONE PLACE YOU CHANGE TO SWAP STYLES
// ------------------------------------------------------------
// To swap: change ACTIVE_THEME to any id below ('bender',
// 'talladega', 'nashville') and run npm start.
// ============================================================

import bender    from './bender';
import talladega from './talladega';
import nashville from './nashville';

export const themes = {
  bender,
  talladega,
  nashville,
};

// --- THE SWITCH ---
export const ACTIVE_THEME = 'bender';   // ← flip this

// --- RUNTIME EXPORT ---
// Components import { theme } and read theme.labels.* / theme.map.* / etc.
// The build-time apply-theme.js script still reads `themes[ACTIVE_THEME]`
// directly to inject CSS, so this is purely additive.
export const theme = themes[ACTIVE_THEME];

export default theme;
